import { Pipe, PipeTransform } from '@angular/core';
import { PreferenceInstrumentClass } from "../../scp/preferences/models";

@Pipe({
name: 'filterByRentableItem'
})
export class FilterByRentabalItemPipe implements PipeTransform
{
  transform(items: PreferenceInstrumentClass[]): PreferenceInstrumentClass [] {
    if (!items) {
        return items;
    }

    return items.filter(si => si.isRentable || (!si.isRentable && si.hasSupplyPkg)).sort((a, b) => a.rentalCategoryCode?.localeCompare(b.rentalCategoryCode));
  }
}
